/* lua.js generated code 0.3.0 */

require("clover/logic/UserEnergy")
var UserLevelTypeBase = require("clover/logic/userLevel/UserLevelTypeBase")
var UserLevelTypeMainLevel = xClass("UserLevelTypeMainLevel", UserLevelTypeBase)
require("clover/data/ItemDataManager")
UserLevelTypeMainLevel.prototype.canStartLevel = function (levelId, itemList, notVague) {
    var self = this
    var topLevel = UserManager.getInstance().getUserRef().getTopLevelId()
    if (levelId > topLevel) {
        return [false, ZooErrorCode.LEVEL_ID_INVALID_START_LEVEL]
    }
    var [success, errCode] = self.canStartLevel_checkInitProp(levelId, itemList)
    if (!success) {
        return [success, errCode]
    }
    if (this.isHaveComplementStarItem(itemList)){// 检测商品中是否有补星道具有道具 如果有 不检测体力
        return [true, undefined]
    }

    var consumeEnergy = self.getConsumeEnergy(levelId, !notVague)
    if (!UserEnergy.getInstance().checkEnergy(consumeEnergy)) {
        return [false, ZooErrorCode.ENERGY_NOT_ENOUGH]
    }
    return [true, undefined]
}
// 检测商品中是否有补星道具
UserLevelTypeMainLevel.prototype.isHaveComplementStarItem = function (itemList) {
    for (var i = 1, v = itemList[1]; v; i++, v = itemList[i]) {
        if (this.checkComplementStarItem(v)){
            return true
        }
    }
    return false
}
// 检查是否是补星道具
UserLevelTypeMainLevel.prototype.checkComplementStarItem = function (itemId) {
    return GamePropsType.kComplementStar == itemId || GamePropsType.kComplementStar2 == itemId
    
}
UserLevelTypeMainLevel.prototype.canStartLevel_checkInitProp = function (levelId, itemList) {
    var gameMode = LevelConfigManager.getInstance().getLevelGameMode(levelId)
    if (!gameMode) {
        return [false, ZooErrorCode.STAGE_INFO_NOT_EXIST]
    }
    var [propMeta, initPropList] = [MetaManager.getGameModePropByModeId(gameMode), table()]
    //  因为propMeta现在使用的是新的Item信息，所以在检查的时候要转化成旧格式进行检查
    var propMetaPropList = table()
    for (var i in propMeta.initProps_item) {
        for (var j in propMeta.initProps_item[i]) {
            var itemData = ItemDataManager.getItemDataById(propMeta.initProps_item[i][j])
            if (!table.indexOf(propMetaPropList || table(), itemData.propId)) {
                table.insert(propMetaPropList, itemData.propId)
            }
        }
    }
    let infiPropState = UserManager.getInstance().isInfiPrePropState(levelId)
    for (var i = 1, v = itemList[1]; v; i++, v = itemList[i]) {
        if (!this.checkComplementStarItem(v) && !table.indexOf(propMetaPropList || table(), v) && !UserPropData.isInfinitePreProp(v) && !UserPropData.isLitmitedPreProp(v)) {
            return [false, ZooErrorCode.ADD_PROP_MODE_ERROR_START_LEVEL]
        }
        if (UserProp.getInstance().getAvaliablePropNumber(v) < 1 && !infiPropState) {
            return [false, ZooErrorCode.PROP_NOT_ENOUGH]
            //table.insert(initPropList, v)
        }
    }
    for (var i = 1, v = itemList[1]; v; i++, v = itemList[i]) {
        if (ItemType.isPassLevelPropLock(v, levelId)) {
            return [false, ZooErrorCode.USE_PRE_PROP_NOT_PASS_LEVEL]
        }
    }
    // var [needCoin, needCash] = [0, 0]
    // for (var i = 1, v = initPropList[1]; v; i++, v = initPropList[i]) {
    //     var goodsId = UserDealData.getGoodsIdForProp(v)
    //     var discountGoodsId = UserDealData.getDiscountGoodsIdIfAvaliable(goodsId, 1)
    //     if (discountGoodsId) {
    //         goodsId = discountGoodsId
    //     }
    //     var [success, errCode] = UserDeal.getInstance().canBuyGoods(goodsId, 1)
    //     if (!success) {
    //         return [false, errCode]
    //     }
    //     var goodsMeta = MetaManager.getInstance().getGoodsMeta(goodsId)
    //     var payType = UserDealData.getGoodsPayType(goodsId)
    //     if (payType === UserDealPayType.kCoin) {
    //         needCoin = needCoin + goodsMeta.coin
    //     } else if (payType === UserDealPayType.kCash) {
    //         needCash = needCash + (goodsMeta.discountQCash !== 0 && goodsMeta.discountQCash || goodsMeta.qCash)
    //     } else {
    //         return [false, ZooErrorCode.BUY_WRONG_MONEY_TYPE]
    //     }
    // }
    // if (!UserCoin.getInstance().checkCoin(needCoin)) {
    //     return [false, ZooErrorCode.COIN_NOT_ENOUGH]
    // }
    // if (!UserCash.getInstance().checkCash(needCash)) {
    //     return [false, ZooErrorCode.CASH_NOT_ENOUGH]
    // }
    return [true, undefined]
}
UserLevelTypeMainLevel.prototype.ctor = function (levelId, itemList) {
    var self = this
    UserLevelTypeBase.prototype.ctor.call(self, levelId, itemList)
    self.levelType = GameLevelType.kMainLevel
}
UserLevelTypeMainLevel.prototype.getConsumeEnergy = function (levelId, vague) {
    var self = this
    // body
    if (type(levelId) === "number") {
        if (MetaManager.getInstance().getIsGuideByLevelId(levelId)) {
            var score = UserScore.getInstance().getScore(levelId)
            if (score && score.star > 0) {
                return 0
            }
        }
    }
    //console.log("[monthticket] getConsumeEnergy vague:"+vague)
    var energyConsume = MetaManager.getInstance().global.user_energy_level_consume || 5
    // if (UserManager.getInstance().isHaveEquityMonthTicket(vague)){
    //     energyConsume = 4
    // }
    
    return energyConsume
}
UserLevelTypeMainLevel.prototype.startLevel = function (levelId, itemList, successCallback, failCallback, cancelCallback) {
    var self = this
    // var consumeEnergy = self.getConsumeEnergy(levelId)
    function onSuccess(event) {
        // UserEnergy.getInstance().unlockEnergy(consumeEnergy)
        // UserEnergy.getInstance().consumeEnergy(consumeEnergy)
        if (successCallback) {
            successCallback(event)
        }
    }
    function onFail(event) {
        // UserEnergy.getInstance().unlockEnergy(consumeEnergy)
        if (failCallback) {
            failCallback(event)
        }
    }
    function onCancel() {
        // UserEnergy.getInstance().unlockEnergy(consumeEnergy)
        if (cancelCallback) {
            cancelCallback()
        }
    }
    // UserEnergy.getInstance().lockEnergy(consumeEnergy)
    // function buyPropSuccess() {
    //     UserLevelTypeBase.prototype.startLevel.call(self, levelId, itemList, onSuccess, onFail, onCancel)
    // }
    // UserLevelTypeBase.prototype.startLevel_buyInitProp.call(self, levelId, itemList, buyPropSuccess, onFail)
    
    //  因为主线关卡的关前道具不再使用勾选后自动购买逻辑，因此不再执行购买逻辑，直接返回onSuccess
    // UserLevelTypeBase.prototype.startLevel_buyInitProp.call(self, levelId, itemList, onSuccess, onFail, onCancel)
    onSuccess()
}
UserLevelTypeMainLevel.prototype.canUseProp = function (propId, num) {
    var self = this
    var [success, errCode] = UserLevelTypeBase.prototype.canUseProp_checkRange.call(self, propId)
    if (!success) {
        return [success, errCode]
    }
    var [success, errCode] = UserLevelTypeBase.prototype.canUseProp_checkUseTime.call(self, propId, num)
    if (!success) {
        return [success, errCode]
    }
    return [true]
}
UserLevelTypeMainLevel.prototype.endLevel = function (score, star, stageTime, coin, targetCount, opLog, costMove, replay, successCallback, failCallback, cancelCallback, otherData, cleanRetry) {
    var self = this
    otherData = otherData || {}
    function buildrewardList(event) {
        var scoreRef, oldScore
        // var topLevel = UserManager.getInstance().getUserRef().getTopLevelId()
        if (otherData.challengeLevelId) {
            // 挑战逻辑：完成关卡，且以前打过这一关，则更新分数/星星
            var challengeScoreRef = UserScore.getScore(otherData.challengeLevelId)
            if (challengeScoreRef && challengeScoreRef.star > 0 && challengeScoreRef.score > 0 && otherData.targetDone) {
                [scoreRef, oldScore] = UserScore.getInstance().updateScore(self.levelId, Math.max(score, challengeScoreRef.score), Math.max(star, challengeScoreRef.star));
            } else {
                scoreRef = oldScore = challengeScoreRef;
            }
        } else {
            [scoreRef, oldScore] = UserScore.getInstance().updateScore(self.levelId, score, star)
        }
        // if (otherData.wantedId || (challengeScoreRef && challengeScoreRef.score <= 0 && challengeScoreRef.star <= 0 )) {
        //     scoreRef = oldScore = UserScore.getInstance().getScore(self.levelId)
        // }else {
        //     [scoreRef, oldScore] = UserScore.getInstance().updateScore(self.levelId, score, star)
        // }
        // 没有分数时也会有scoreRef对象，因此需要判断星星数和分数才能确定是否有过关记录
        if (scoreRef && scoreRef.star > 0 && scoreRef.score > 0) {
            var user = UserManager.getInstance().getUserRef()
            var $var22 = oldScore.star + 1,$limit23 = scoreRef.star
            for (var i = $var22; i <= $limit23; i += 1) {
                if (i <= 2) {
                    user.setYellowStar(user.getYellowStar() + 1)
                } else if (i <= 3) {
                    user.setOrangeStar(user.getOrangeStar() + 1)
                } else {
                    user.setBlueStar(user.getBlueStar() + 1)
                }
            }
            var rewardList = ((event || table()).data || table()).rewardItems || table()
            if ($len(rewardList) > 0) {
                for (var i = 1, v = rewardList[1]; v; i++, v = rewardList[i]) {
                    UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.STAGE_REWARD)
                }
            }
            var topLevel = UserManager.getInstance().getUserRef().getTopLevelId()
            if (star > 0 && topLevel === self.levelId) {
                if (topLevel !== UserManager.getInstance().getMaxLevelServer()) {
                    UserManager.getInstance().getUserRef().setTopLevelId(topLevel + 1)
                    UserScore.getInstance().dispatchNewTopLevelTemp()
                }
            }
        }
    }

    function onSuccess(event) {
        cc.log("UserLevelTypeMainLevel onSuccess ",event)
        buildrewardList(event)
        if (event && event.data){
            PurpleAmyMagicManager.getInstance().updateInfo(event.data.purpleAmyMagic)
            // if (PurpleAmyMagicManager.getInstance().isOpen()){
            // }
            if (event.data.extra.goldElysiumRobotList){
                GoldElysiumManager.getInstance().getData().updateInfo({
                    winningStreak: event.data.extra.goldElysiumWinningStreak,
                    survivalList: event.data.extra.goldElysiumRobotList,
                    winnerList: event.data.extra.goldElysiumWinnerList,
                })
                GoldElysiumManager.getInstance().dcGoldElysiumChangeResult(star > 0,otherData.src || "fail",self.levelId)
            }
            //投篮增加材料数
            let extra = event.data.extra
            if (extra.dunkAceScoreNum >= 0){
                if (extra.dunkAceScoreNum > 0){
                    DunkAceLogic.getInstance().addMaterialNum(extra.dunkAceScoreNum)
                }
                DCAssist.dc4DunkAce("play_stage", DCAssist.dcForStartGameParams.session, {

                    current_stage: self.levelId,
                    result :extra.dunkAceScoreNum > 0 ? 2 : 1,
                    num: extra.dunkAceScoreNum,
                    plt : extra.dunkAceComboLevelNum,
                    type : DunkAceLogic.getInstance().getStrategyType()
                    // t2: extra.continueWin,
                    // yellowstar: $len(self.data.info.ranks),

                })
                DunkAceData.getInstance().updateInfo({comboLevelNum : extra.dunkAceComboLevelNum + 1})
            }
            UserManager.getInstance().getUserExtendRef().setTopLevelStreak(event.data.topLevelStreak)
            UserManager.getInstance().setLastShowOffTime(event.data.lastShowOffTime); // 上次真求超越的时间

            if (event.data.levelPreItemUnlockReward){
                for (let i = 1; i <= $len(event.data.levelPreItemUnlockReward); i++) {
                    let prop = event.data.levelPreItemUnlockReward[i]
                    UserProp.getInstance().rewardProp(tonumber(prop.itemId), tonumber(prop.num), null, null, "bef_stage_item_unlock")
                }
            }
        }
        if (successCallback) {
            successCallback(event)
        }
    }
    function onFail(event) {
        buildrewardList(event)        
        if (failCallback) {
            failCallback(event)
        }
    }
    function onCancel() {
        if (cancelCallback) {
            cancelCallback(event)
        }
    }
    var scoreRef = UserManager.getInstance().getUserScore(self.levelId)
    if (otherData.loadingPanelId){
        self.loadingPanelId = otherData.loadingPanelId
    }
    if (star >= 0 || (scoreRef && scoreRef.score < score) || otherData.contestUid) {
        DCAssist.dc4LevelUserOp170(self.levelId)
        self.sendEndRequest(score, star, stageTime, coin, targetCount, opLog, costMove, replay, onSuccess, onFail, onCancel, otherData, cleanRetry)
    } else {
        onSuccess()
    }
}
module.exports = UserLevelTypeMainLevel
